import moment from 'moment';
import contractDetailServices from '@/views/ContractDetail/ContractDetailServices';

import { DATE_FORMAT, DISPLAY_DATE_FORMAT } from '@/consts';

import {
  CLEAR_INFO,
  SET_INFO
} from './types';


export default {

  async getContractRedeemInfo({ commit }, id) {
    const data = await contractDetailServices.getContractDetail(id);

    const info = {
      id: data.id,
      mifosId: data.mifosId,
      active: data.active,
      status: data.status,
      totalOutstanding: data.totalOutstanding / 1000000,
      transactionDate: moment().format(DISPLAY_DATE_FORMAT),
      dueDate: moment(data.dueDate, DATE_FORMAT).format(DISPLAY_DATE_FORMAT),
      prepaid: data.product.prepaid,
      repayEvery: data.product.repayEvery,
      client: data.client,
      branch: data.branch,
      storage: data.storage,
      principalAmount: data.principalAmount / 1000000,
      interestAmount: data.interestAmount / 1000000,
      promotionAmount: data.promotionAmount / 1000000,
    };

    commit(SET_INFO, info);
  },

  clearInfo({ commit }) {
    commit(CLEAR_INFO);
  },

  setInfo({ commit }, info) {
    commit(SET_INFO, info);
  },
};
